module.exports = __webpack_public_path__ + "img/eq-hammerdin-shield.95213e75.png";